
  export default {
    name: 'Footer',
    // Any reactive data or methods would go here
  }
  